export const mockDetectorDetail = {
  id: 1,
  name: "TestPhaseStatQuery - Detector Report",
  description: "@@@@",
  agency_id: "00ec4d3e-f446-4ec5-9169-81a1a6d16391",
  from_date: "2021-05-04",
  to_date: "2021-05-05",
  created_at: "2024-04-08T08:21:34.148+00:00",
  owner_id: 1185,
  owner: {
    id: 1185,
    name: "Son Anh Nguyen",
    email: "anh.nguyen@eastgate-software.com",
  },
  from_time: "10:00:00",
  to_time: "14:00:00",
  agency_name: "Lawrence",
  timezone: "+07:00",
  week_days: [
    "WEDNESDAY",
    "TUESDAY",
    "MONDAY",
    "FRIDAY",
    "THURSDAY",
    "SUNDAY",
    "SATURDAY",
  ],
  aggregation: "HOURLY",
  num_of_int: 22,
  chart_data_aggregate: [
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[2,4,5,6,8],"detector_data":{"34":{"phase_data":{"2":{"total_activation":344,"occupancy":0.6199116488310105,"avg_volume":0.9577777777777777,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":57,"occupancy":0.7633406033823216,"avg_volume":0.15861111111111112,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"37":{"phase_data":{"5":{"total_activation":52,"occupancy":0.3554218574688146,"avg_volume":0.14666666666666667,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":256,"occupancy":0.6857052510454082,"avg_volume":0.7111111111111111,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":43,"occupancy":0.4846700863474022,"avg_volume":0.12055555555555557,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,3,4,5,6,7,8],"detector_data":{"1":{"det_type":"StopBar","phase_data":{"1":{"total_activation":77,"occupancy":2.062874676594939,"avg_volume":0.2138888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"2":{"phase_data":{"2":{"total_activation":172,"occupancy":0.6694189821657182,"avg_volume":0.47916666666666663,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"3":{"phase_data":{"3":{"total_activation":60,"occupancy":0.4073144490013824,"avg_volume":0.1675,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"4":{"phase_data":{"4":{"total_activation":53,"occupancy":0.3781245437522864,"avg_volume":0.14722222222222223,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"5":{"det_type":"StopBar","phase_data":{"5":{"total_activation":49,"occupancy":0.269568296099555,"avg_volume":0.1363888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"6":{"phase_data":{"6":{"total_activation":191,"occupancy":0.6588204538010297,"avg_volume":0.5319444444444444,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"7":{"det_type":"StopBar","phase_data":{"7":{"total_activation":42,"occupancy":0.6673662593286633,"avg_volume":0.11777777777777777,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"8":{"phase_data":{"8":{"total_activation":75,"occupancy":0.46951796828302017,"avg_volume":0.21000000000000002,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[2,4,6,8],"detector_data":{"34":{"phase_data":{"2":{"total_activation":359,"occupancy":0.5720282407918382,"avg_volume":0.9974999999999999,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":71,"occupancy":0.7334028521187058,"avg_volume":0.19916666666666666,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":282,"occupancy":0.6197101549775889,"avg_volume":0.7850000000000001,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":45,"occupancy":0.41178762205431624,"avg_volume":0.1275,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,4,5,6,8],"detector_data":{"33":{"phase_data":{"1":{"total_activation":45,"occupancy":0.23909592158538756,"avg_volume":0.12583333333333335,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"34":{"phase_data":{"2":{"total_activation":287,"occupancy":0.6207685233401831,"avg_volume":0.7991666666666666,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":52,"occupancy":0.795540523474072,"avg_volume":0.14527777777777778,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"37":{"phase_data":{"5":{"total_activation":48,"occupancy":0.3038497149085944,"avg_volume":0.13583333333333333,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":272,"occupancy":0.655857601638233,"avg_volume":0.7575000000000001,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":46,"occupancy":0.4298423593916116,"avg_volume":0.12777777777777777,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,4,5,6,7,8],"detector_data":{"1":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"1":{"total_activation":25,"occupancy":0.17229196246561612,"avg_volume":0.06944444444444445,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"2":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"2":{"total_activation":243,"occupancy":0.6169015436015617,"avg_volume":0.6766666666666666,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"4":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"4":{"total_activation":61,"occupancy":0.377727011733738,"avg_volume":0.16999999999999998,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"5":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"5":{"total_activation":49,"occupancy":0.2965356169958046,"avg_volume":0.1363888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"6":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"6":{"total_activation":314,"occupancy":0.5851146446667366,"avg_volume":0.8730555555555557,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"7":{"det_type":"Advance","distance_to_stop_bar":0.0,"phase_data":{"7":{"total_activation":48,"occupancy":0.5830796273329469,"avg_volume":0.135,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"8":{"phase_data":{"8":{"total_activation":38,"occupancy":0.594720011702751,"avg_volume":0.1077777777777778,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[2,4,5,6,8],"detector_data":{"34":{"phase_data":{"2":{"total_activation":295,"occupancy":0.5167637122321008,"avg_volume":0.8216666666666668,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":65,"occupancy":0.5033152532295732,"avg_volume":0.18194444444444444,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"37":{"phase_data":{"5":{"total_activation":67,"occupancy":0.3275217676091057,"avg_volume":0.18611111111111114,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":331,"occupancy":0.5037349342973337,"avg_volume":0.9211111111111111,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":32,"occupancy":0.4247997238812459,"avg_volume":0.0888888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,3,6],"detector_data":{"1":{"det_type":"StopBar","phase_data":{"1":{"total_activation":218,"occupancy":0.6199383685865864,"avg_volume":0.6077777777777778,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"2":{"det_type":"StopBar","phase_data":{"2":{"total_activation":163,"occupancy":0.6902464921454186,"avg_volume":0.455,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"3":{"det_type":"Advance","distance_to_stop_bar":50.0,"phase_data":{"3":{"total_activation":49,"occupancy":0.7549425470129578,"avg_volume":0.1375,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"6":{"det_type":"StopBar","phase_data":{"6":{"total_activation":254,"occupancy":0.5335924371932393,"avg_volume":0.7080555555555554,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,3,4,5,6,7,8],"detector_data":{"1":{"det_type":"RedLightViolation","phase_data":{"1":{"total_activation":35,"occupancy":0.7693081227744651,"avg_volume":0.0975,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"2":{"det_type":"RedLightViolation","phase_data":{"2":{"total_activation":109,"occupancy":0.8276779260085372,"avg_volume":0.305,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"3":{"det_type":"RedLightViolation","phase_data":{"3":{"total_activation":47,"occupancy":0.7156482429187647,"avg_volume":0.13277777777777777,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"4":{"det_type":"RedLightViolation","phase_data":{"4":{"total_activation":51,"occupancy":0.6949499052235872,"avg_volume":0.14277777777777775,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"5":{"det_type":"RedLightViolation","phase_data":{"5":{"total_activation":26,"occupancy":0.4509354661338378,"avg_volume":0.07388888888888888,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"6":{"det_type":"RedLightViolation","phase_data":{"6":{"total_activation":198,"occupancy":0.715315890865163,"avg_volume":0.5519444444444443,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"7":{"det_type":"RedLightViolation","phase_data":{"7":{"total_activation":37,"occupancy":0.4288374703094299,"avg_volume":0.10333333333333336,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"8":{"det_type":"RedLightViolation","phase_data":{"8":{"total_activation":69,"occupancy":0.6899633035353049,"avg_volume":0.19416666666666665,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,3,4,5,6,7,8],"detector_data":{"1":{"phase_data":{"1":{"total_activation":41,"occupancy":0.3202020778533922,"avg_volume":0.11611111111111112,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"2":{"phase_data":{"2":{"total_activation":175,"occupancy":0.7465819575140731,"avg_volume":0.48833333333333334,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"3":{"det_type":"RedLightViolation","phase_data":{"3":{"total_activation":42,"occupancy":0.46332489761577744,"avg_volume":0.11861111111111111,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"4":{"phase_data":{"4":{"total_activation":71,"occupancy":0.6747885786556728,"avg_volume":0.19805555555555554,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"5":{"det_type":"RedLightViolation","phase_data":{"5":{"total_activation":41,"occupancy":0.3231186416756572,"avg_volume":0.11555555555555555,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"6":{"phase_data":{"6":{"total_activation":189,"occupancy":0.7498976634153626,"avg_volume":0.5272222222222223,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"7":{"phase_data":{"7":{"total_activation":51,"occupancy":0.5791403676935075,"avg_volume":0.1436111111111111,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"8":{"phase_data":{"8":{"total_activation":59,"occupancy":0.6193188463735451,"avg_volume":0.1663888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,4,5,6,8],"detector_data":{"33":{"phase_data":{"1":{"total_activation":37,"occupancy":0.14197726407177624,"avg_volume":0.10277777777777777,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"34":{"phase_data":{"2":{"total_activation":355,"occupancy":0.51850601935778,"avg_volume":0.9883333333333333,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":36,"occupancy":0.311825851090361,"avg_volume":0.10166666666666667,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"37":{"phase_data":{"5":{"total_activation":18,"occupancy":0.19310655732196655,"avg_volume":0.05138888888888889,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":292,"occupancy":0.5929437502170145,"avg_volume":0.811388888888889,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":41,"occupancy":0.46320743263171876,"avg_volume":0.11416666666666667,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[1,2,3,4,5,6,7,8],"detector_data":{"33":{"phase_data":{"1":{"total_activation":36,"occupancy":0.49773407871211106,"avg_volume":0.10055555555555555,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"34":{"phase_data":{"2":{"total_activation":122,"occupancy":0.6343026506886069,"avg_volume":0.3399999999999999,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"35":{"phase_data":{"3":{"total_activation":46,"occupancy":0.7130306251328836,"avg_volume":0.12999999999999998,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"36":{"phase_data":{"4":{"total_activation":72,"occupancy":0.6885476294902098,"avg_volume":0.20222222222222225,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"37":{"phase_data":{"5":{"total_activation":49,"occupancy":0.822476552356657,"avg_volume":0.13722222222222222,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"38":{"phase_data":{"6":{"total_activation":105,"occupancy":0.7672528174515534,"avg_volume":0.29361111111111116,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"39":{"phase_data":{"7":{"total_activation":47,"occupancy":0.642650104710674,"avg_volume":0.13249999999999998,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"40":{"phase_data":{"8":{"total_activation":76,"occupancy":0.6787992681897418,"avg_volume":0.2125,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[2,4],"detector_data":{"2":{"det_type":"RedLightViolation","phase_data":{"2":{"total_activation":541,"occupancy":0.6645153669240654,"avg_volume":1.5044444444444445,"is_total_act_satisfy_condition":false,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}},"4":{"det_type":"RedLightViolation","phase_data":{"4":{"total_activation":27,"occupancy":0.23048520387161647,"avg_volume":0.07722222222222222,"is_total_act_satisfy_condition":true,"is_occupancy_satisfy_condition":false,"is_avg_volume_satisfy_condition":false}}}}}',
    '{"from_time":"2021-05-04T00:00:00","to_time":"2021-05-05T00:00:00","call_phases":[],"detector_data":{}}',
  ],
};

export const mockDetailChart = {
  detail_chart: [
    {
      from_time: "2021-05-04T10:00:00",
      to_time: "2021-05-04T11:00:00",
      call_phases: [1, 2, 3, 4, 5, 6, 7, 8],
      detector_data: {
        1: {
          det_type: "RedLightViolation",
          phase_data: {
            1: {
              total_activation: 34,
              occupancy: 0.7626173708920188,
              avg_volume: 0.009444444444444445,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        2: {
          det_type: "RedLightViolation",
          phase_data: {
            2: {
              total_activation: 114,
              occupancy: 0.7283950617283951,
              avg_volume: 0.03166666666666667,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        3: {
          det_type: "RedLightViolation",
          phase_data: {
            3: {
              total_activation: 48,
              occupancy: 0.6610718492343934,
              avg_volume: 0.013333333333333334,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        4: {
          det_type: "RedLightViolation",
          phase_data: {
            4: {
              total_activation: 49,
              occupancy: 0.6785388127853881,
              avg_volume: 0.01361111111111111,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        5: {
          det_type: "RedLightViolation",
          phase_data: {
            5: {
              total_activation: 22,
              occupancy: 0.30868582499192765,
              avg_volume: 0.006111111111111111,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        6: {
          det_type: "RedLightViolation",
          phase_data: {
            6: {
              total_activation: 220,
              occupancy: 0.6483710008805401,
              avg_volume: 0.06111111111111111,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        7: {
          det_type: "RedLightViolation",
          phase_data: {
            7: {
              total_activation: 35,
              occupancy: 0.3199882249043273,
              avg_volume: 0.009722222222222222,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        8: {
          det_type: "RedLightViolation",
          phase_data: {
            8: {
              total_activation: 62,
              occupancy: 0.5530280649926145,
              avg_volume: 0.017222222222222222,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
      },
    },
    {
      from_time: "2021-05-04T11:00:00",
      to_time: "2021-05-04T12:00:00",
      call_phases: [1, 2, 3, 4, 5, 6, 7, 8],
      detector_data: {
        1: {
          det_type: "RedLightViolation",
          phase_data: {
            1: {
              total_activation: 45,
              occupancy: 0.7855664004732328,
              avg_volume: 0.0125,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        2: {
          det_type: "RedLightViolation",
          phase_data: {
            2: {
              total_activation: 99,
              occupancy: 0.8699379249187112,
              avg_volume: 0.0275,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        3: {
          det_type: "RedLightViolation",
          phase_data: {
            3: {
              total_activation: 58,
              occupancy: 0.677723763225622,
              avg_volume: 0.01611111111111111,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        4: {
          det_type: "RedLightViolation",
          phase_data: {
            4: {
              total_activation: 55,
              occupancy: 0.6865158889206986,
              avg_volume: 0.015277777777777777,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        5: {
          det_type: "RedLightViolation",
          phase_data: {
            5: {
              total_activation: 29,
              occupancy: 0.5124544349939246,
              avg_volume: 0.008055555555555555,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        6: {
          det_type: "RedLightViolation",
          phase_data: {
            6: {
              total_activation: 180,
              occupancy: 0.7688651218062983,
              avg_volume: 0.05,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        7: {
          det_type: "RedLightViolation",
          phase_data: {
            7: {
              total_activation: 36,
              occupancy: 0.42681532304173814,
              avg_volume: 0.01,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        8: {
          det_type: "RedLightViolation",
          phase_data: {
            8: {
              total_activation: 77,
              occupancy: 0.6286205907657012,
              avg_volume: 0.021388888888888888,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
      },
    },
    {
      from_time: "2021-05-05T10:00:00",
      to_time: "2021-05-05T11:00:00",
      call_phases: [1, 2, 3, 4, 5, 6, 7, 8],
      detector_data: {
        1: {
          det_type: "RedLightViolation",
          phase_data: {
            1: {
              total_activation: 33,
              occupancy: 0.6967551622418879,
              avg_volume: 0.009166666666666667,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        2: {
          det_type: "RedLightViolation",
          phase_data: {
            2: {
              total_activation: 108,
              occupancy: 0.8135143110061965,
              avg_volume: 0.03,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        3: {
          det_type: "RedLightViolation",
          phase_data: {
            3: {
              total_activation: 49,
              occupancy: 0.6314735336194564,
              avg_volume: 0.01361111111111111,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        4: {
          det_type: "RedLightViolation",
          phase_data: {
            4: {
              total_activation: 51,
              occupancy: 0.5831663326653307,
              avg_volume: 0.014166666666666666,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        5: {
          det_type: "RedLightViolation",
          phase_data: {
            5: {
              total_activation: 26,
              occupancy: 0.37971698113207547,
              avg_volume: 0.007222222222222222,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        6: {
          det_type: "RedLightViolation",
          phase_data: {
            6: {
              total_activation: 221,
              occupancy: 0.5840472673559822,
              avg_volume: 0.06138888888888889,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        7: {
          det_type: "RedLightViolation",
          phase_data: {
            7: {
              total_activation: 38,
              occupancy: 0.35744924220760654,
              avg_volume: 0.010555555555555556,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        8: {
          det_type: "RedLightViolation",
          phase_data: {
            8: {
              total_activation: 61,
              occupancy: 0.6801375752364575,
              avg_volume: 0.016944444444444446,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
      },
    },
    {
      from_time: "2021-05-05T11:00:00",
      to_time: "2021-05-05T12:00:00",
      call_phases: [1, 2, 3, 4, 5, 6, 7, 8],
      detector_data: {
        1: {
          det_type: "RedLightViolation",
          phase_data: {
            1: {
              total_activation: 30,
              occupancy: 0.7836722664308872,
              avg_volume: 0.008333333333333333,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        2: {
          det_type: "RedLightViolation",
          phase_data: {
            2: {
              total_activation: 101,
              occupancy: 0.8362348775449985,
              avg_volume: 0.028055555555555556,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        3: {
          det_type: "RedLightViolation",
          phase_data: {
            3: {
              total_activation: 52,
              occupancy: 0.7162639952857984,
              avg_volume: 0.014444444444444444,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        4: {
          det_type: "RedLightViolation",
          phase_data: {
            4: {
              total_activation: 48,
              occupancy: 0.7839470655926352,
              avg_volume: 0.013333333333333334,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        5: {
          det_type: "RedLightViolation",
          phase_data: {
            5: {
              total_activation: 28,
              occupancy: 0.5217245989304813,
              avg_volume: 0.0077777777777777776,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        6: {
          det_type: "RedLightViolation",
          phase_data: {
            6: {
              total_activation: 189,
              occupancy: 0.738913362701909,
              avg_volume: 0.0525,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        7: {
          det_type: "RedLightViolation",
          phase_data: {
            7: {
              total_activation: 35,
              occupancy: 0.42415316642120765,
              avg_volume: 0.009722222222222222,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
        8: {
          det_type: "RedLightViolation",
          phase_data: {
            8: {
              total_activation: 72,
              occupancy: 0.7078812107367218,
              avg_volume: 0.02,
              is_total_act_satisfy_condition: true,
              is_occupancy_satisfy_condition: true,
              is_avg_volume_satisfy_condition: true,
            },
          },
        },
      },
    },
  ],
};
